import Loadable from 'react-loadable';

import AgentProfilePageComponent from './index';

const LazyAgentProfile = Loadable({
	loader: () => import(/* webpackChunkName: "async-ptc_agent-profile-page" */ './index'),
	loading: () => null,
});
LazyAgentProfile.displayName = 'lazy(AgentProfile)';

export default AgentProfilePageComponent;
